// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1950":"c7300e6e0cf3139e","5803":"9b3aa517f9907f21"}[chunkId] + ".js";
};